import { render, staticRenderFns } from "./AttachmentSvg.vue?vue&type=template&id=77411436&scoped=true&functional=true&"
var script = {}
import style0 from "./AttachmentSvg.vue?vue&type=style&index=0&id=77411436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "77411436",
  null
  
)

export default component.exports